import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Plus from '../../svg/Plus';
import DotSvg from '../../svg/DotSvg';
import { useDispatch } from 'react-redux';
import { clearFocusSection } from '../../store/focuspage/focuspageSlice';

export default function AddCard({ txt, link, dotimgclss }) {

    const navigate = useNavigate()
    const dispatch = useDispatch();

    return (
        <div className='p-4 py-6 flex w-full justify-between items-center'>
            <div className='flex items-center'>
                <span className='text-white'>{txt}</span>
                {dotimgclss && (

                    <DotSvg width={6} height={6} color={'red'} className='ml-2' />

                )}
            </div>
            <div onClick={() => {
                navigate(link);
                dispatch(clearFocusSection())
            }}>
                <Plus className='h-[12px] w-[12px]  cursor-pointer' />
                {/* <img src={plus} alt='plus'  /> */}
            </div>
        </div>
    );
}
